var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"check_fto_component"}},[_c('h3',[_c('router-link',{attrs:{"to":{ name: 'Calculator' }}},[_vm._v("Check how many FTOs you would get in each mining package"),_c('br',{staticClass:"desktop-only"}),_vm._v(" if you had it now.")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f0710690","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/partials/section/content/calculator/CheckFTO.vue
// module id = dZ8A
// module chunks = 0